<template>
  <div>
    <Header></Header>

    <div v-if="haveAccess">
      <div class="MethodHead">
        <Pict
          :card="card"
          :showEditLink="showEditLink"
          :saveData="updateCardParams"
        ></Pict>

        <OpisBlock
          :card="card"
          :showEditLink="showEditLink"
          :saveDataColumns="updateCardColumns"
          :saveDataParams="updateCardParams"
        ></OpisBlock>
      </div>

      <div class="BeruzaLine">
        <div class="YFL"></div>
        <div class="YFR"></div>
        <div class="MABlock">
          <div class="MAva" :style='{ backgroundImage: `url(${card.author.avatar_preview_40})` }'></div>
          <div class="Redactor">{{ roles[card.author.role] }} <router-link :to="{ name: 'user', params: { id: card.author_id }}">{{ card.author.name }}</router-link></div>
          <div class="MVersion">Версия от {{ card.date }}</div>
        </div>
        <!-- <div id="YBt1" class="YBt"><div class="YIcon" style="background-image: url('img/y-icon-1.png');"></div>Подробное<br/>руководство</div>
        <div id="YBt2" class="YBt"><div class="YIcon" style="background-image: url('img/y-icon-2.png');"></div>Печатные<br/>материалы</div>
        <div id="YBt3" class="YBt"><div class="YIcon" style="background-image: url('img/y-icon-3.png');"></div>Слайды<br/>с правилами</div>
        <div id="YBt4" class="YBt"><div class="YIcon" style="background-image: url('img/y-icon-4.png');"></div>Фото и видео<br/>примеры</div>
        <div id="YBt5" class="YBt"><div class="YIcon" style="background-image: url('img/y-icon-5.png');"></div>Кейсы<br/>и фишки</div> -->
      </div>

      <div class="ShadowBig">
        <Comments
          :cardId="id"
          :card="card"
        ></Comments>
      </div>

      <div class="OpisanieBlock">
        <table>
          <tr>
            <th class="Opisanie">
              <div class="OLeft">
                <DescriptionName
                  :card="card"
                ></DescriptionName>

                <DescriptionText
                  :card="card"
                  :showEditLink="showEditLink"
                  :saveData="updateCardParams"
                ></DescriptionText>
              </div>
            </th>
            <th>
              <Uses
                :card="card"
                :showEditLink="showEditLink"
                :saveData="updateCardParams"
              ></Uses>
            </th>
          </tr>

        </table>
      </div>

      <HistoryText
        :card="card"
        :showEditLink="showEditLink"
        :saveData="updateCardParams"
      ></HistoryText>

      <Files
        :card="card"
        :showEditLink="showEditLink"
        :saveData="updateCardParams"
      ></Files>

      <Links
        :card="card"
        :showEditLink="showEditLink"
        :saveData="updateCardParams"
      ></Links>

      <Pictures
        :card="card"
        :showEditLink="showEditLink"
        :saveData="updateCardParams"
      ></Pictures>

      <!-- <div class="AM">
        <div class="Zg">Похожие методы</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import OpisBlock from "@/components/card/OpisBlock.vue";
import Pict from "@/components/card/Pict.vue";
import DescriptionName from "@/components/card/DescriptionName.vue";
import DescriptionText from "@/components/card/DescriptionText.vue";
import Uses from "@/components/card/Uses.vue";
import HistoryText from "@/components/card/HistoryText.vue";
import Files from "@/components/card/Files.vue";
import Links from "@/components/card/Links.vue";
import Pictures from "@/components/card/Pictures.vue";
import Comments from "@/components/card/Comments.vue";
import { mapGetters } from 'vuex';
import store from "@/store";
import { ROLES } from "@/utils/roles";
import { pick, isEmpty } from 'lodash';
import { API_ROOT } from "@/utils/api_root";

require('vue-flash-message/dist/vue-flash-message.min.css');

export default {
  props: {
    id: { type: Number, default: 0 }
  },
  components: {
    Header, OpisBlock, Pict, DescriptionName, DescriptionText,
    Uses, HistoryText, Files, Links, Pictures, Comments
  },
  data() {
    return {
      roles: ROLES,
    };
  },
  methods: {
    updateCardColumns(columns, onSuccess) {
      console.log('Card component updateCardColumns this', this);
      const params = pick(this.card, columns);
      console.log('updateCardColumns params', params);
      // this.cardOpisErrors = {};

      // this.updateCardParams.call(this, {card: params}, editFlag);
      this.updateCardParams({card: params}, onSuccess);
    },
    // updateCardParams(params, editFlag, reloadColumns = false) {
    updateCardParams(params, onSuccess, reloadColumns = false) {
      console.log('updateCardParams params', params, onSuccess);
      this.$http.patch(`${API_ROOT}/cards/${this.card.id}.json`, params)
        .then(response => {
          console.log('updateCardColumns success', response.data);
          // this.card = response.data;
          if (Array.isArray(reloadColumns)) {
            reloadColumns.forEach((value, key) => {
              console.log('updateCardParams column', value);
              this.card[value] = response.data[value];
            })
          }
          // if (editFlag) this.toggleEditMode(editFlag);
          console.log('updateCardParams onSuccess', onSuccess);
          if (onSuccess) onSuccess();
          this.flash('Данные сохранены', 'success', {timeout: 3000});
        })
        .catch(error => {
          console.log('updateCardColumns error', error, error.response);
          this.flash('Ошибка сохранения', 'error');
          // this.cardOpisErrors = error.response.data;
        });
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    showEditLink: function() {
      console.log('currentUser', this.currentUser);
      console.log('card', this.card);
      return this.currentUser.id == this.card.author_id ||
             this.currentUser.role == 'admin';
    },
    haveAccess: function() {
      return this.card.visible || this.showEditLink;
    },
    card: {
      get() {
        return this.$store.getters.card(this.id);
        // return this.$store.state.cards[this.id] || {};
      },
      set(value) {
        this.$store.commit('card', value);
      }
    },
  },
  beforeRouteEnter: async function (to, from, next) {
    console.log('Card component beforeRouteEnter');
    await store.dispatch('loadCard', to.params.id);
    next();
  }
};
</script>

<style>

.MyTakeNum{
  position: absolute;
  top: 34px;
  right: 46px;
  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  color: #b6b6b6;
}

.MyIconBt{
  position: absolute;
  right: 20px;
  top: 30px;
  width: 22px;
  height: 22px;
  border: 0px solid #cccccc;
  cursor: pointer;
}

.MyIconBt.Add{
  background-image: url("/img/take-icon-off.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.MyIconBt.Remove{
  background-image: url("/img/take-icon-on.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.MyIconBt.Add:hover{
  background-image: url("/img/take-icon-on.png");
}
.MyIconBt.Remove:hover{
  background-image: url("/img/take-icon-off.png");
}

.MIBlock{
  position: relative;
  width: 280px;
  min-height: 100px;
  margin-left: 60px;
  margin-top: 15px;
  padding: 3px;
  font-family: 'Open Sans', sans-serif;
  color: #6d6d6d;
  /* font-style: italic; */
  font-size: 15px;
}

.MIBlockE{
  position: relative;
  width: 280px;
  min-height: 100px;
  margin-left: 60px;
  margin-top: 20px;
  padding: 3px;
  border-radius: 5px;
  font-family: 'Open Sans', sans-serif;
  color: #6d6d6d;
  /* font-style: italic; */
  font-size: 15px;
}

.MObnovlenie{
  position: absolute;
  bottom: 0px;
  left: 60px;
  width: 200px;
  height: 25px;
  font-family: 'Open Sans', sans-serif;
  color: #b9b9b9;
  font-style: italic;
  font-size: 12px;
  border: 0px solid #666;
}

.MethodHead{
  position: relative;
  margin: 50px auto 0px auto;
  width: 1200px;
  height: 450px;
  border: 0px solid #cccccc;
}

.MethodObl{
  position: absolute;
  left: 0px;
  top: 0px;
  width: 800px;
  height: 450px;
  background-color: #888;
  background-repeat: no-repeat;
    background-size: cover;
}

.AddObl{
  position: absolute;
  cursor: pointer;
  padding-top: 10px;
  right: 10px;
  bottom: 10px;
  width: 130px;
  height: 50px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-size: 14px;
  text-align: center;
  border-radius: 5px;
  background-color: #FFF;
  opacity: 0.7;
}

.MethodOpisBlock{
  position: absolute;
  right: 0px;
  top: 0px;
  width: 400px;
  height: 450px;
  background-color: #FFF;
}

.MethodOpisBlockEdit{
  position: absolute;
  right: 0px;
  top: 0px;
  width: 400px;
  height: 450px;
  background-color: rgb(254, 247, 202);
}

.VisBt{
  position: absolute;
  cursor: pointer;
  right: -40px;
  top: 30px;
  width: 40px;
  height: 80px;
  background-repeat: no-repeat;
    background-size: cover;
}

.VisBt.On {
  background-image: url('../assets/img/vis-on.png');
}
.VisBt.Off {
  background-image: url('../assets/img/vis-off.png');
}

.EditBt{
  position: absolute;
  cursor: pointer;
  right: -40px;
  top: 135px;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
    background-size: cover;
}

.EditBt.Add{
  background-image: url('../assets/img/add-icon.png');
}
.EditBt.Edit{
  background-image: url('../assets/img/edit-small.png');
}

.EditTxtBt{
  position: absolute;
  cursor: pointer;
  right: -40px;
  top: -3px;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-size: cover;
}

.EditTxtBt.Add{
  background-image: url('../assets/img/add-icon.png');
}
.EditTxtBt.Edit{
  background-image: url('../assets/img/edit-small.png');
}

.TrashBt{
  position: absolute;
  cursor: pointer;
  right: -45px;
  top: -4px;
  width: 30px;
  height: 30px;
  background-image: url('../assets/img/trash-icon.png');
  background-repeat: no-repeat;
    background-size: cover;
  opacity: 0.3;
}

.AddBt{
  position: absolute;
  cursor: pointer;
  right: -45px;
  top: -3px;
  width: 40px;
  height: 40px;
  background-image: url('../assets/img/add-icon.png');
  background-repeat: no-repeat;
    background-size: cover;
  opacity: 0.8;
}

.YellowLine{
  position: relative;
  margin: 0px auto;
  width: 1200px;
  height: 60px;
  background-color: #80f1ff;

}

.BeruzaLine{
  position: relative;
  margin: 0px auto;
  width: 1200px;
  height: 60px;
  background-color: #80f1ff;

}

.MABlock{
  position: absolute;
  right: 30px;
  top: 10px;
  width: 310px;
  height: 40px;
  border: 0px solid #888;
}

.MAva{
  position: absolute;
  left: 0px;
  top: 0px;
  height:40px;
  width: 40px;
  background-color: #888;
  background-repeat: no-repeat;
    background-size: cover;
}

.Redactor{
  position: absolute;
  left: 55px;
  top: 3px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-style: regular;
  font-size: 14px;
  border: 0px solid #cccccc;
}

.MVersion{
  position: absolute;
  left: 55px;
  top: 23px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-style: italic;
  font-size: 12px;
  border: 0px solid #cccccc;
}

.YIcon{
  position: absolute;
  left: 0px;
  top: 1px;
  width: 30px;
  height: 30px;
  border: 0px solid #ccc;
  background-repeat: no-repeat;
    background-size: cover;
}

.YFL{
  position: absolute;
  left: -35px;
  top: 2px;
  width: 35px;
  height: 56px;
  background-image: url("../assets/img/y-flag-left.png");
  background-position: right top;
  background-repeat: no-repeat;
}

.YFR{
  position: absolute;
  right: -35px;
  top: 2px;
  width: 35px;
  height: 56px;
  background-image: url("../assets/img/y-flag-right.png");
  background-position: left top;
  background-repeat: no-repeat;
}

.YBt{
  position: absolute;
  top: 15px;
  width: 160px;
  height: 40px;
  padding-left: 38px;
  border: 0px solid #ccc;
  font-family: 'Fira Sans Condensed', sans-serif;
  color: #19636c;
  font-weight: normal;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 0.3;
}

.YBt:hover{
  color: #000;
}


#YBt1{
  left: 60px;
}

#YBt2{
  left: 280px;
}

#YBt3{
  left: 500px;
}

#YBt4{
  left: 720px;
}

#YBt5{
  left: 940px;
}

.ShadowBig{
  position: relative;
  margin: 0px auto;
  width: 1200px;
  height: 80px;
  background-image: url("../assets/img/shadow-big.png");
  background-position: center top;
  background-repeat: no-repeat;
}



.MMarkers{
  margin-left: 50px;
  margin-top: 30px;
  min-height: 40px;
}



.MMName{
  margin-left: 60px;
  margin-top: 60px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: bold;
  font-size: 36px;
  line-height: 1.1;

}



.MVName{
  width: 274px;
  margin-left: 60px;
  margin-top: 5px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #505050;
  font-weight: 300;
  font-size: 20px;
}

.MVNameE{
  width: 274px;
  border-radius: 5px;
  margin-left: 60px;
  margin-top: 0px;
  padding: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #505050;
  font-weight: 300;
  font-size: 20px;
}


.MPeople{
  width: 253px;
  min-height: 26px;
  margin-left: 60px;
  margin-top: 20px;
  margin-bottom: 5px;
  padding-top: 3px;
  padding-left: 28px;
  /* font-family: 'Fira Sans Condensed', sans-serif;
  font-family: 'Open Sans', sans-serif;  */
  font-family: 'Roboto Condensed', sans-serif;
  color: #6d6d6d;
  font-weight: 300;
  font-size: 20px;
  padding-bottom: 3px;
  background-image: url("../assets/img/icon-24x24-1.png");
  background-position: 0px 2px;
  background-repeat: no-repeat;
}

.MPeopleE{
  width: 253px;
  margin-left: 60px;
  margin-top: 20px;
  margin-bottom: 5px;
  padding-top: 3px;
  padding-left: 28px;
  /* font-family: 'Fira Sans Condensed', sans-serif;
  font-family: 'Open Sans', sans-serif;  */
  font-family: 'Roboto Condensed', sans-serif;
  color: #6d6d6d;
  font-weight: 300;
  font-size: 20px;
  padding-bottom: 3px;
  border-radius: 5px;
  background-image: url("../assets/img/icon-24x24-1.png");
  background-position: 0px 2px;
  background-repeat: no-repeat;
}


.MHours{
  width: 253px;
  min-height: 26px;
  margin-left: 60px;
  /* font-family: 'Fira Sans Condensed', sans-serif;
  font-family: 'Open Sans', sans-serif;  */
  font-family: 'Roboto Condensed', sans-serif;
  color: #6d6d6d;
  font-weight: 300;
  font-size: 20px;
  padding-top: 3px;
  padding-left: 28px;
  padding-bottom: 3px;
  background-image: url("../assets/img/icon-24x24-2.png");
  background-position: left 2px;
  background-repeat: no-repeat;
}

.MHoursE{
  width: 253px;
  margin-left: 60px;
  /* font-family: 'Fira Sans Condensed', sans-serif;
  font-family: 'Open Sans', sans-serif;  */
  font-family: 'Roboto Condensed', sans-serif;
  color: #6d6d6d;
  font-weight: 300;
  font-size: 20px;
  padding-top: 3px;
  padding-left: 28px;
  padding-bottom: 3px;
  border-radius: 5px;
  background-image: url("../assets/img/icon-24x24-2.png");
  background-position: left 2px;
  background-repeat: no-repeat;
}



.OpisanieBlock{
  position: relative;
  margin: 0px auto;
  width: 1200px;
  border: 0px solid #cccccc;
}

.OpisanieBlock th{
  font-weight: normal;
  vertical-align: top;
}

.OpisanieBlock th.Opisanie{
  width: 850px;
}

.OLeft{
  position: relative;
  left: 60px;
  top: 0px;
  width: 700px;
}

.OLeftEdit{
  position: relative;
  left: 60px;
  top: 0px;
  width: 700px;
}

.Ozg{
  position: relative;
  top:0px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: normal;
  font-size: 28px;
  text-align: left;
  margin-bottom: 30px;
}

.Ozg.Padding{
  padding: 3px;
}

.Ozgl{
  position: relative;
  width: 700px;
}

.Otxtl{
  position: relative;
  top: 0px;
  width: 700px;
}

.Htxtl{
  position: relative;
  margin-left: 60px;
  width: 700px;
}

.OzgE{
  position: relative;
  width: 690px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  padding: 3px;
  font-weight: normal;
  font-size: 28px;
  text-align: left;
  margin-bottom: 30px;
  border-radius: 5px;
}

.Otxt{
  position: relative;
  padding-left: 3px;
  /* font-family: 'Fira Sans Condensed', sans-serif;
  font-family: 'Roboto', sans-serif;
  font-family: 'Roboto Condensed', sans-serif;  */
  min-height: 120px;
  font-family: 'Open Sans', sans-serif;
  color: #555;
  font-weight: nodmal;
  font-size: 16px;
  text-align: left;
  line-height: 1.5;
  margin-bottom: 60px;
}

.Otxt b {
  color: #000;
}
.Otxt i {
  background-color: #FFF; /* faeeb3 */
  padding-left: 5px;
  padding-right: 5px;
}

.Otxt p,
.Htxt p {
  margin-block-start: 0em;
  margin-block-end: 0em;
}

.OtxtE,
.HtxtE{
  position: relative;
  width: 690px;
  padding-left: 3px;
  /* font-family: 'Fira Sans Condensed', sans-serif;
  font-family: 'Roboto', sans-serif;
  font-family: 'Roboto Condensed', sans-serif;  */
  min-height: 120px;
  font-family: 'Open Sans', sans-serif;
  color: #555;
  font-weight: normal;
  font-size: 16px;
  text-align: left;
  line-height: 1.5;
  border-radius: 5px;
  margin-bottom: 60px;
}

.ORight{
  /* position: absolute; */
  left: 860px;
  top: 0px;
  width: 260px;
}

.Oplus{
  position: relative;
  padding-bottom: 25px;
  padding-left: 30px;
  width: 240px;
  /* font-family: 'Fira Sans Condensed', sans-serif;
  font-family: 'Open Sans', sans-serif; */
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: nodmal;
  font-size: 18px;
  text-align: left;
  background-image: url("../assets/img/plus-icon.png");
  background-position: left top;
  background-repeat: no-repeat;
}

.Oadd{
  position: relative;
  width: 277px;
  padding-bottom: 25px;
  background-image: url("../assets/img/plusadd-icon.png");
  background-position: left top;
  background-repeat: no-repeat;
}

.FilesBlock{
  position: relative;
  margin: 0px auto;
  padding-top: 30px;
  /*padding-bottom: 50px;*/
  padding-bottom: 30px;
  width: 1200px;
  /* height: 300px; */
  border-top: 1px solid #cccccc;
}

.FilesBlock.Edit{
  padding-bottom: 50px;
}

.FilesLine{
  width: 850px;
  margin-left:50px;
  border: 0px solid #cccccc;
  /* display: grid; */
    /* clear: both; */
}

.FileBox{
  position: relative;
  width: 180px;
  /* height: 180px; */
  margin-left: 10px;
  margin-right: 10px;
  border: 0px solid #cccccc;
  display: inline-table;
  padding-top: 10px;
  padding-bottom: 40px;
  clear: both;
}

.FileIcon{
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
    background-size: cover;
}

.FileIcon.pdf{
  background-image: url(../assets/img/pdf-icon.png)
}
.FileIcon.doc,
.FileIcon.docx {
  background-image: url(../assets/img/doc-icon.png)
}

.FileOpisanie{
  /* font-family: 'Times New Roman', sans-serif; */
  font-family: 'Open Sans', sans-serif;
  color: #6d6d6d;
  /* font-style: italic; */
  font-size: 13px;
  text-align: left;
  padding-top: 8px;
  padding-bottom: 10px;
  text-decoration: none;
}

a.FileLink:link,
a.FileLink:visited,
a.FileLink:hover,
a.FileLink:active {
  text-decoration: none;
}

.PhotoBlock{
  position: relative;
  margin: 0px auto;
  width: 1200px;
  border-top: 1px solid #cccccc;
  padding-top: 30px;
  padding-bottom: 30px;
}

.PhotoBlock.Edit{
  padding-bottom: 50px;
}

.PhotoLine{
  width: 850px;
  margin-left:50px;
  border: 0px solid #cccccc;
  /* display: grid; */
    /* clear: both; */
}

.PhotoBox{
  position: relative;
  width: 180px;
  padding-top: 10px;
  padding-bottom: 40px;
  cursor: pointer;
  /* height: 180px; */
  margin-left: 10px;
  margin-right: 10px;
  border: 0px solid #cccccc;
  display: inline-table;
  clear: both;
}

.PhotoSmall{
  width: 180px;
  height: 120px;
  background-repeat: no-repeat;
    background-size: cover;
}

.PhotoOpisanie{
  /* font-family: 'Times New Roman', sans-serif; */
  font-family: 'Open Sans', sans-serif;
  color: #6d6d6d;
  /* font-style: italic; */
  font-size: 13px;
  text-align: left;
  padding-top: 8px;
  padding-bottom: 10px;
}

.HistoryBlock{
  position: relative;
  margin: 0px auto;
  width: 1200px;
  /* height: 300px; */
  border-top: 1px solid #cccccc;
  padding-top: 30px;
  padding-bottom: 30px;
}

.Htxt{
  position: relative;
  width: 700px;
  padding-left: 3px;
  margin-left: 60px;
  /* font-family: 'Roboto', sans-serif; */
  min-height: 120px;
  font-family: 'Open Sans', sans-serif;
  color: #555;
  font-weight: nodmal;
  font-size: 16px;
  text-align: left;
  line-height: 1.5;
  /*margin-bottom: 30px;*/
  margin-bottom: 20px;
}

.Htxt b{
  color: #000;
}

.AddBlock{
  position: absolute;
  cursor: pointer;
  right: 60px;
  top: 25px;
  width: 100px;
  height: 50px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #fff;
  font-weight: bold;
  padding-top: 20px;
  padding-left: 80px;
  font-size: 14px;
  text-align: left;
  line-height:18px;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-position: 30px 16px;
  background-color: #37bbd6;
}

.AddBlock.Files {
  background-image: url('../assets/img/files-icons.png')
}

.AddBlock.Links {
  background-image: url('../assets/img/links-icons.png')
}

.AddBlock.Picts {
  background-image: url('../assets/img/picts-icons.png')
}

.EditBlock{
  position: absolute;
  left: -7px;
  bottom: 15px;
  width: 80px;
  height: 30px;
  border: 0px solid #999;
}

.GearBt{
  position: absolute;
  cursor: pointer;
  left: 0px;
  top: 0px;
  width: 30px;
  height: 30px;
  background-image: url("../assets/img/gear-icon.png");
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.4;
}

.DelBt{
  position: absolute;
  cursor: pointer;
  left: 32px;
  top: 0px;
  width: 30px;
  height: 30px;
  background-image: url("../assets/img/trash-icon.png");
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.4;
}

.AddBlock:hover{
  background-color: #1ba1bd;
}

.Oinput{
  position: relative;
  width: 250px;
  padding-left: 5px;
  height: 30px;
  left: 15px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #555;
  font-weight: normal;
  font-size: 18px;
  font-size: 18px;
  text-align: left;
  border-radius: 5px;
}

.AM{
  position: relative;
  margin: 0px auto;
  width: 1200px;
  /* height: 300px; */
  border-top: 1px solid #cccccc;
  padding-top: 30px;
  padding-bottom: 0px;
}

.Zg{
  position: relative;
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: nodmal;
  font-size: 28px;
  text-align: left;
  padding-left: 60px;
  padding-bottom: 30px;
}

.BorderRadius {
  border-radius: 5px;
  border: 1px solid #fff;
}

.PopUpAdd{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: #323938;
  border-top: 1px solid #ccc; */
  z-index: 10;
}

.PopUpFon{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: #323938;
  opacity: 0.9;

}

.PopUpPanel{
  position: absolute;
  left: 50%;
  top: 15%;
}

.PopUpBlock{
  position: absolute;
  left: -200px;
  top: 0px;
  width: 400px;
  height: 410px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 10px 40px #000;
}

.PopUpName{
  position: absolute;
  top: 30px;
  left: 40px;
  width: 220px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 24px;
  color: #000000;
}

.PopUpClose{
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: -40px;
  width: 40px;
  height: 40px;
  background-image: url("../assets/img/close.png");
  background-size: cover;
}

.Rline3{
  position: absolute;
    top: 80px;
    left: 30px;
    width: 340px;
    border-top: 1px solid #ccc;
}

.FileLoad{
  position: absolute;
  left: 35px;
  top: 120px;
  width: 270px;
  height: 30px;
  font-family: 'Fira Sans Condensed', sans-serif;
  font-size: 14px;
  color: #888;
}

.LinkLoad{
  position: absolute;
  left: 35px;
  top: 105px;
  width: 270px;
  height: 22px;
  padding: 5px;
  font-family: 'Fira Sans Condensed', sans-serif;
  font-size: 14px;
  color: #888;
  border-radius: 5px;
}


.FileOpisForma{
  position: absolute;
  left: 35px;
  top: 150px;
  width: 270px;
  min-height: 80px;
  padding: 5px;
  border-radius: 5px;
  font-family: 'Open Sans', sans-serif;
  color: #6d6d6d;
  /* font-style: italic; */
  font-size: 13px;
}

.FLError{
  position: absolute;
    top: 250px;
    left: 30px;
    width: 240px;
    height: 40px;
    padding-left: 10px;
  text-align: left;
    font-family: "Roboto";
    font-size: 9pt;
    color: #e50808;
}

.BtFileLoad{
  position: absolute;
  top: 290px;
  right: 40px;
  width: 150px;
  height:40px;
  font-family: 'Fira Sans Condensed', sans-serif;
  font-size: 18px;
  color: #fff;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #37bbd6
}

</style>
